import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ProposalFieldsJSON: {},
  ProposalLayoutJSON: [],
  ProposalRulesJSON: [],
  ProfileInfoData: {},
  createDetails: {},
  orderId: null,
  data: {},
  proposalJson: "",
  activeTab: "details",
  summaryDetails: {},
  url: "",
};

const buyNowSlice = createSlice({
  name: "buyNow",
  initialState: initialState,
  reducers: {
    setProposalFieldsJSON: (state, action) => {
      state.ProposalFieldsJSON = action.payload;
    },
    setProposalLayoutJSON: (state, action) => {
      state.ProposalLayoutJSON = action.payload;
    },
    setProposalRulesJSON: (state, action) => {
      state.ProposalRulesJSON = action.payload;
    },
    setProfileInfoData: (state, action) => {
      state.ProfileInfoData = action.payload;
    },
    setCreateDetailsData: (state, action) => {
      state.createDetails = action.payload;
    },
    setOrderId: (state, action) => {
      state.orderId = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setProposalJson: (state, action) => {
      state.proposalJson = action.payload;
    },
    changeActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setSummaryDetails: (state, action) => {
      state.summaryDetails = action.payload;
    },
    setUrl: (state, action) => {
      state.url = action.payload;
    },
  },
});
export const {
  setFormData,
  setProposalFieldsJSON,
  setProposalLayoutJSON,
  setProposalRulesJSON,
  setProfileInfoData,
  setCreateDetailsData,
  setOrderId,
  setData,
  setProposalJson,
  changeActiveTab,
  setSummaryDetails,
  setUrl,
} = buyNowSlice.actions;

export default buyNowSlice.reducer;
